import { useEffect, useRef } from "react";
import { useToast } from "./toast/ToastProvider";

type AutoDismissNoticeProps = {
  title: string;
  description?: string;
  durationMs?: number;
  closeLabel?: string;
};

export function AutoDismissNotice({
  title,
  description,
  durationMs = 10000,
}: AutoDismissNoticeProps) {
  const toast = useToast();
  const lastKeyRef = useRef<string | null>(null);

  useEffect(() => {
    const key = `success:${title}:${description ?? ""}:${durationMs}`;
    if (lastKeyRef.current === key) {
      return;
    }
    lastKeyRef.current = key;
    toast.success(title, description, { durationMs });
  }, [description, durationMs, title, toast]);

  return null;
}
